import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  projects: {
    width: 100,
    height: 100,
    paths: [
      {
        style: `fill: #eb212e`,
        d: `M16,59,5.17,63.38A2.49,2.49,0,0,1,1.92,62L.19,57.71a2.49,2.49,0,0,1,1.38-3.25l9.58-3.86ZM98.41,25.87a2.49,
        2.49,0,0,0,1.38-3.25l-1.72-4.29a2.51,2.51,0,0,0-3.25-1.39L39.61,39.15a17,17,0,0,1-2.12,6.45L33.9,51.82l6.46-2.6,9.08,
        8.27a22.78,22.78,0,0,1-.34-6,21.73,21.73,0,0,1,1.53-6.38h0A22.78,22.78,0,0,1,70.53,30.86l1,0a22.4,22.4,0,0,1,9.4,2.07Zm.83,
        63.47L84.42,75.85l-5.09,8.84,13.21,12a2.29,2.29,0,0,0,3.23-.15l3.63-4A2.28,2.28,0,0,0,99.24,89.34Z`,
      },
      {
        style: `fill: #4d4d4d`,
        d: `M46.89,2.68a9.93,9.93,0,0,0-8.65,8.22,9.79,9.79,0,0,0,1.19,6.5l7.8,13.54a.87.87,
          0,0,0,1.52,0L56.56,17.4A9.87,9.87,0,0,0,46.89,2.68Zm.85,15.25a5.39,5.39,0,1,1,5.39-5.39A5.39,5.39,0,0,1,47.74,17.93Z`,
      },
      {
        style: `fill: #4d4d4d`,
        d: `M22.41,23.39A14,14,0,0,0,9,37.14a13.81,13.81,0,0,0,1.84,
        7L22,63.46a1,1,0,0,0,1.7,0L34.89,44.11A13.85,13.85,0,0,0,22.41,23.39Zm.47,21.53a7.65,7.65,0,
        1,1,7.65-7.65A7.64,7.64,0,0,1,22.88,44.92Z`,
      },
      {
        style: `fill: #4d4d4d`,
        d: `M70.66,33.86A19.62,19.62,0,0,0,52.09,51.72,19.42,19.42,0,0,0,54.61,63l16,27.8a1,1,0,0,0,
          1.72,0l16-27.8A19.45,19.45,0,0,0,70.66,33.86Zm.84,30.29A10.79,10.79,0,1,1,82.29,53.36,10.79,10.79,0,0,1,71.5,64.15Z`,
      },
    ],
  },
});
